module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section section-white content-padded",
    attrs: {
      "onload": "init()"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否是国内门店"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [(_vm.form.wx_shop_id) ? _c('el-radio-group', {
    on: {
      "change": _vm.isDomesticChange
    },
    model: {
      value: (_vm.form.is_domestic),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_domestic", $$v)
      },
      expression: "form.is_domestic"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1,
      "value": "1",
      "disabled": ""
    }
  }, [_vm._v("国内")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2,
      "value": "2",
      "disabled": ""
    }
  }, [_vm._v("非国内")])], 1) : _c('el-radio-group', {
    on: {
      "change": _vm.isDomesticChange
    },
    model: {
      value: (_vm.form.is_domestic),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_domestic", $$v)
      },
      expression: "form.is_domestic"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1,
      "value": "1"
    }
  }, [_vm._v("国内")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2,
      "value": "2"
    }
  }, [_vm._v("非国内")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否是直营店"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.is_direct_store),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_direct_store", $$v)
      },
      expression: "form.is_direct_store"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1,
      "value": "1"
    }
  }, [_vm._v("直营店")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2,
      "value": "2"
    }
  }, [_vm._v("非直营店")])], 1)], 1)], 1), _vm._v(" "), (_vm.form.is_domestic == 1) ? _c('el-form-item', {
    attrs: {
      "label": "地理位置"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-cascader', {
    attrs: {
      "options": _vm.regions,
      "change-on-select": ""
    },
    on: {
      "change": _vm.handleRegionChange
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-input', {
    attrs: {
      "id": "keyword",
      "placeholder": "请输入门店名称"
    },
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-center",
    attrs: {
      "span": 1
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.searchKeyword()
      }
    }
  }, [_vm._v("搜索定位")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.is_domestic == 1) ? _c('el-form-item', {
    attrs: {
      "label": "地图定位"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    attrs: {
      "id": "qqmap_rslist"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    attrs: {
      "id": "qqmap_container"
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "门店名称"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请先完成上方地理位置的选择"
    },
    model: {
      value: (_vm.form.shopname),
      callback: function($$v) {
        _vm.$set(_vm.form, "shopname", $$v)
      },
      expression: "form.shopname"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.form.is_domestic == '2') ? _c('el-form-item', {
    attrs: {
      "label": "具体地址"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "国家"
    },
    model: {
      value: (_vm.form.country),
      callback: function($$v) {
        _vm.$set(_vm.form, "country", $$v)
      },
      expression: "form.country"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-center",
    attrs: {
      "span": 1
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "城市"
    },
    model: {
      value: (_vm.form.city),
      callback: function($$v) {
        _vm.$set(_vm.form, "city", $$v)
      },
      expression: "form.city"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-center",
    attrs: {
      "span": 1
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "详细地址"
    },
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.form.is_domestic == 2) ? _c('el-form-item', {
    attrs: {
      "label": "经营资质名称"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.company_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "company_name", $$v)
      },
      expression: "form.company_name"
    }
  })], 1), _vm._v(" "), _c('el-col', [_c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("请填写营业执照名称，或组织机构代码证名称。")])])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": "true",
      "label": "门店经纬度"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": "",
      "placeholder": "经度"
    },
    model: {
      value: (_vm.form.lng),
      callback: function($$v) {
        _vm.$set(_vm.form, "lng", $$v)
      },
      expression: "form.lng"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-center",
    attrs: {
      "span": 1
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": "",
      "placeholder": "纬度"
    },
    model: {
      value: (_vm.form.lat),
      callback: function($$v) {
        _vm.$set(_vm.form, "lat", $$v)
      },
      expression: "form.lat"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "门店图片"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("请上传门店图片如门店内、外景图、门店服务信息等，图片将展示在微信客户端的门店页。"), _c('br'), _vm._v("最多可上传9个图片，文件格式为bmp、png、jpeg、jpg或gif，大小不超过2M")]), _vm._v(" "), _c('div', {
    staticClass: "pics-box"
  }, [_c('ul', {
    staticClass: "goodspic-wrap"
  }, _vm._l((_vm.form.pic_list), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "goodspic",
      on: {
        "mouseenter": function($event) {
          return _vm.picsEnter(index)
        },
        "mouseleave": _vm.picsLeave
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.wximageurl + item
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "goodspic-mask",
      class: (_vm.picsCurrent == index) ? 'on' : '',
      on: {
        "click": function($event) {
          return _vm.removePicsImg(index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-trash-alt1 icon1"
    })])])
  }), 0), _vm._v(" "), (_vm.form.pic_list.length < 9) ? _c('div', {
    staticClass: "upload-box",
    on: {
      "click": _vm.handlePicsChange
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]) : _vm._e()]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.picsDialog,
      "sc-status": _vm.isGetPics,
      "isMost": true
    },
    on: {
      "chooseImg": _vm.pickPics,
      "closeImgDialog": _vm.closePicsDialog
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客服电话"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.contract_phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "contract_phone", $$v)
      },
      expression: "form.contract_phone"
    }
  })], 1), _vm._v(" "), _c('el-col', [_c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("固定电话需加区号；区号、分机号均用“-”连接")])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业时间"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-time-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "is-range": "",
      "format": "HH:mm",
      "type": "fixed-time",
      "placeholder": "营业时间"
    },
    on: {
      "change": _vm.selectDateChange
    },
    model: {
      value: (_vm.opentime),
      callback: function($$v) {
        _vm.opentime = $$v
      },
      expression: "opentime"
    }
  })], 1), _vm._v(" "), _c('el-col', [_c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("24小时制，如10：00-20：30")])])], 1), _vm._v(" "), (_vm.form.is_domestic == '1') ? _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.add_flag === 1),
      expression: "add_flag===1"
    }],
    attrs: {
      "label": "经营资质主体"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.add_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "add_type", $$v)
      },
      expression: "form.add_type"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("公众账号主体 "), _c('span', {
    staticClass: "frm-tips"
  }, [_vm._v("(" + _vm._s(_vm.principal_name) + ")")])])], 1), _vm._v(" "), _c('div', [_c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("相关主体 "), _c('span', {
    staticClass: "frm-tips"
  }, [_vm._v("(若地点的经营资质名称与帐号主体名称不一致，请选择相关主体。)")])])], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.form.is_domestic == 1) ? _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.add_type == '2' && _vm.add_flag === 1),
      expression: "form.add_type=='2' && add_flag===1"
    }],
    attrs: {
      "label": "经营资质名称"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.company_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "company_name", $$v)
      },
      expression: "form.company_name"
    }
  })], 1), _vm._v(" "), _c('el-col', [_c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("请填写营业执照名称，或组织机构代码证名称。")])])], 1) : _vm._e(), _vm._v(" "), (_vm.form.is_domestic == 1) ? _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.add_flag === 1),
      expression: "add_flag===1"
    }],
    attrs: {
      "label": "经营资质证件号"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.credential),
      callback: function($$v) {
        _vm.$set(_vm.form, "credential", $$v)
      },
      expression: "form.credential"
    }
  })], 1), _vm._v(" "), _c('el-col', [_c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("请填写15位营业执照注册号或9位组织机构代码（如12345678-9）或18位或20位统一社会信用代码")])])], 1) : _vm._e(), _vm._v(" "), (_vm.form.is_domestic == 1) ? _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.add_type == '2' && _vm.add_flag === 1),
      expression: "form.add_type=='2' && add_flag===1"
    }],
    attrs: {
      "label": "相关证明材料"
    }
  }, [_c('el-col', [_c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("提交能证明此经营资质主体与帐号主体相关的证明材料。文件格式为bmp、png、jpeg、jpg或gif，大小不超过2M。")])]), _vm._v(" "), _c('el-col', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "auto-upload": false,
      "show-file-list": false,
      "on-change": _vm.handleQualificationPicChange
    }
  }, [(_vm.qpic_url) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.qpic_url
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "large"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.qqmap_infowin_flag),
      expression: "qqmap_infowin_flag"
    }],
    attrs: {
      "id": "qqmap_infowin"
    }
  }, [_c('el-col', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.imp_poi(_vm.poi_info)
      }
    }
  }, [_vm._v("导入该门店信息")])], 1), _vm._v(" "), _c('el-col', [_vm._v(_vm._s(_vm.poi_info.id))]), _vm._v(" "), _c('el-col', [_vm._v(_vm._s(_vm.poi_info.name) + "," + _vm._s(_vm.poi_info.address))])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ee33109e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee33109e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/shop/editstore.vue
// module id = 2970
// module chunks = 0